// base
import React, { Component } from 'react';

// components
import {
  Layout,
  PageState,
  Search,
  Pager,
  ContentsBox,
  BlocksComponent,
  TransactionsComponent,
  IsLoadingLayout
} from '../../components';
import ReactTooltip from 'react-tooltip';

// assets
import './blocks.scss';
import { blocks, transactionListByBlock } from "../../../api";
import { connect } from 'react-redux';

class Blocks extends Component {

  constructor(props) {
    super(props);
    this.state = this.initState();
  };

  initState = () => {
    return {
      blocks: null,
      transactions: null,
      pageNum: 1,
      pages: 1,
      currentBlockNumber: null,
    };
  };

  getBlocks = (pageNum) => {
    blocks(pageNum).then((res) => {
      if (res.data) {
        this.getTransactions(res.data.list[0].number);
        this.setState({
          blocks: res.data.list,
          pageNum: res.data.pageNum,
          pages: res.data.pages,
        });
      }
    }).catch((err) => {
      console.error(err);
    });
  };

  movePage = (action) => {
    const { pageNum, pages } = this.state;

    if (action === 'next' && pageNum < pages) {
      this.setState({ blocks: null, transactions: null });
      this.getBlocks(pageNum + 1);
    } else if (action === 'prv' && pageNum > 1) {
      this.setState({ blocks: null, transactions: null });
      this.getBlocks(pageNum - 1);
    } else if (action === 'first') {
      this.setState({ blocks: null, transactions: null });
      this.getBlocks(1);
    } else if (action === 'last') {
      this.setState({ blocks: null, transactions: null });
      this.getBlocks(pages);
    }
  };

  getTransactions = (blockNumber) => {
    transactionListByBlock(blockNumber).then((res) => {
      if (res.data) {
        this.setState({
          transactions: res.data,
          currentBlockNumber: blockNumber,
        });
      }
    }).catch((err) => {
      console.error(err);
    });
  };

  changeTransaction = (e, blockNumber) => {
    this.setState({ transactions: null });
    this.getTransactions(blockNumber);
  };

  loadPage = () => {
    this.getBlocks(1);
  };

  componentDidMount() {
    this.loadPage();
  };

  componentDidUpdate() {
    ReactTooltip.rebuild();
  };

  render() {
    const { blocks, transactions, pageNum, pages, currentBlockNumber } = this.state;

    return (
      <Layout>
        <main className="blocks_main">
          <div className="l-wrapper">
            <div className="page_upper">
              <Search />
              <PageState pageName="Blocks" />
            </div>
            <div className="blocks_contents_group">
              <div className="col blocks">
                <ContentsBox title="Blocks">
                {
                  blocks ?
                  <>
                    <BlocksComponent blocks={blocks} onViewBtnClick={this.changeTransaction} />
                    <div className="blocks_pager">
                      <Pager currentPage={pageNum} totalnum={pages} isFull={true}
                             movepage={this.movePage} />
                    </div>
                  </>
                  :
                  <IsLoadingLayout isLoading={true} />
                }
                </ContentsBox>
              </div>
              <div className="col transactions">
                <ContentsBox title={`Transactions ${transactions ? '(#' + currentBlockNumber + ')' : ''}`}>
                {
                  transactions ?
                  <TransactionsComponent transactions={transactions} type="simple" />
                  :
                  <IsLoadingLayout isLoading={true} />
                }
                </ContentsBox>
              </div>
              <ReactTooltip />
            </div>
          </div>
        </main>
      </Layout>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    network: state.appState.network,
  }
};

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Blocks);
